import { Action, createReducer, on } from '@ngrx/store';
import { IGenericError, ErrorResponse } from '../../../../../src/app/core/models/generic-models';
import * as actions from '../actions';
import { IWithdrawalResponse, IWithdrawalsResponse } from '../models/withdrawals.model';

export const employeeWithdrawalsKey = 'getEmployeeWithdrawals';

export interface EmployeeWithdrawalsState {
  employeeWithdrawalsResponse: IWithdrawalsResponse;
  employeeWithdrawalsFailure: IGenericError<ErrorResponse>;
}

export const initialState: EmployeeWithdrawalsState = {
  employeeWithdrawalsResponse: undefined,
  employeeWithdrawalsFailure: undefined
};

export const reducer = createReducer(
  initialState,

  on(actions.loadEmployeeWithdrawals, (state, action) => ({
    ...state
  })),
  on(actions.loadEmployeeWithdrawalsSuccess, (state, action) => ({
    ...state,
    employeeWithdrawalsResponse: action.response
  })),
  on(actions.loadEmployeeWithdrawalsFailure, (state, action) => ({
    ...state,
    employeeWithdrawalsFailure: action.error
  }))
);

export const getEmployeeWithdrawalsResponse = (state: EmployeeWithdrawalsState) => {
  return state.employeeWithdrawalsResponse;
};
export const getEmployeeWithdrawalsFailure = (state: EmployeeWithdrawalsState) => state.employeeWithdrawalsFailure;
